// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"72":"40944a6e","175":"022290bb","253":"eb7a2924","652":"f499fffa","845":"363acd2b"}[chunkId] + ".js";
};